<template>
  <div class="container-fluid overflow-auto d-flex">
    <div class="w-100 mb-4">
      <div class="row m-0 p-0">
        <div class="col-md-10">
          <h3><i class="fa fa-user-circle"></i> Métricas de Atendimentos</h3>
        </div>
        <div class="col-12 col-md-2 text-md-right mt-3 mt-md-0">
            <defaultbutton
              class="defaultbutton"
              :onClick="() => onShowSearch()"
              btnVariant="btn-third"
              icon="fas fa-search"
              text="Pesquisar"
            />
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-md-6 chart-container">
          <DonutChart :percentages="percentages" :colors="['#FF5733', '#1BACA0']" :label="'Total de Atendimentos: ' + total" :sector-names="['Andamento', 'Finalizados']" />
        </div>
        <div class="col-md-6 chart-container">
          <div v-for="(card, index) in cards" :key="index" class="card-body">
            <h5 class="card-title">{{ card.title }}</h5>
            <p class="card-text">{{ card.text }}</p>
            <div v-if="index === 2" class="rating">
              <template v-if="card.rating !== null">
                <span v-for="n in 10" :key="n" class="star" :class="{ 'filled': n <= card.rating && card.rating >= 5, 'failed': n <= card.rating && card.rating < 5 }">
                  <i class="fa fa-star"></i>
                </span>
                <p class="rating-text">Nota: {{ card.rating }} / 10</p>
              </template>
              <template v-else>
                <p class="no-data">Sem dados disponíveis</p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import SidebarSearch from '@/views/private/atendimento/indice_atendimento/search/SidebarIndiceAtendimento.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import DonutChart from '@/views/private/atendimento/indice_atendimento/components/DonutChart'
/* eslint-disable */

export default {
  name: 'Indice',
  components: {
    defaultbutton,
    SidebarSearch,
    DonutChart
  },
  data () {
    const today = new Date()
    const startDate = new Date()
    startDate.setDate(today.getDate() - 15)
    startDate.setHours(0, 0, 0, 0)
    const endDate = new Date()
    endDate.setHours(23, 59, 59, 999)

    return {
      mobile: false,
      closeFilter: false,
      showFilter: true,
      buttonPosition: {
        top: 7,
        left: 80
      },
      cards: [
        {
          title: 'Tempo Médio de Espera',
          text: 'Carregando...',
          rating: 0
        },
        {
          title: 'Tempo Médio de Atendimento',
          text: 'Carregando...',
          rating: 0
        },
        {
          title: 'Nota Média',
          text: 'Carregando...',
          rating: 0
        }
      ],
      totalAndamento: 0,
      totalFinalizados: 0,
      total: 0,
      percentages: [],
      filters: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Finalizado'
      },
      filtersAndamento: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Aberto'
      }
    }
  },
  created () {
    this.convertWindow()
  },
  mounted () {
    this.getAndamento()
    this.getFinalizado()
    this.onLoadAll()
  },
  computed: {
    isMobile () {
      return window.innerWidth < 768
    }
  },
  methods: {
    handleFilter () {
      this.showFilter = !this.showFilter
    },
    convertWindow () {
      if (this.isMobile) {
        this.buttonPosition = {
          top: 9,
          left: 8
        }
        this.showFilter = false
        this.mobile = true
      } else {
        this.mobile = false
      }
    },
    onApplyFilters (newFilters) {
      this.filters = newFilters
      this.onLoadAll()
    },
    onClearFilters () {
      this.filters = {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Finalizado'
      },
      this.filtersAndamento = {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        operadores: null,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        status: 'Aberto'
      }
      this.onLoadAll()
    },
    onLoadAll () {
      const requestConfigFinalizado = {
        nome: this.filters.nome,
        numeroPA: this.filters.numeroPA,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        numeroTelefone: this.filters.numeroTelefone,
        tipoFinalizacao: this.filters.tipoFinalizacao,
        operadores: this.filters.operadores,
        status: 'Finalizado'
      }

      const requestConfigAndamento = {
        nome: this.filtersAndamento.nome,
        numeroPA: this.filtersAndamento.numeroPA,
        startDate: this.filtersAndamento.startDate,
        endDate: this.filtersAndamento.endDate,
        numeroTelefone: this.filtersAndamento.numeroTelefone,
        tipoFinalizacao: this.filtersAndamento.tipoFinalizacao,
        operadores: this.filtersAndamento.operadores,
        status: 'Aberto'
      }

      Promise.all([
        ReportAtendimentoRepository.MedioGetAll(this.filters, requestConfigFinalizado),
        ReportAtendimentoRepository.MedioGetAll(this.filtersAndamento, requestConfigAndamento)
      ])
      .then(([responseFinalizado, responseAndamento]) => {
        const dataFinalizado = responseFinalizado.data
        const dataAndamento = responseAndamento.data

        this.cards = [
          {
            title: 'Tempo Médio de Espera',
            text: dataFinalizado.mediaTempoEspera ? this.formatTime(dataFinalizado.mediaTempoEspera) : 'Sem dados disponíveis'
          },
          {
            title: 'Tempo Médio de Atendimento',
            text: dataFinalizado.mediaTempoAtendimento ? this.formatTime(dataFinalizado.mediaTempoAtendimento) : 'Sem dados disponíveis'
          },
          {
            title: 'Nota Média',
            rating: dataFinalizado.mediaNotaAtendimento || 0
          }
        ]
      })
      .catch(error => {
        console.error(error)
      })
    },
    async getAndamento () {
      const requestConfigAndamento = {
        nome: this.filters.nome,
        numeroPA: this.filters.numeroPA,
        startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
        endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
        numeroTelefone: this.filters.numeroTelefone,
        tipoFinalizacao: this.filters.tipoFinalizacao,
        operadores: this.filters.operadores,
        status: 'Aberto'
      }

      return AtendimentoRepository.GetPages(this.filtersAndamento, requestConfigAndamento)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.totalAndamento = data.count
            this.calculatePercentages()
          }
        })
    },
    async getFinalizado () {
      const requestConfigFinalizado = {
        nome: this.filters.nome,
        numeroPA: this.filters.numeroPA,
        startDate: this.filters.dataInicial ? new Date(this.filters.dataInicial).toISOString() : null,
        endDate: this.filters.dataFinal ? new Date(this.filters.dataFinal).toISOString() : null,
        numeroTelefone: this.filters.numeroTelefone,
        tipoFinalizacao: this.filters.tipoFinalizacao,
        operadores: this.filters.operadores,
        status: 'Finalizado'
      }

      return AtendimentoRepository.GetPages(this.filters, requestConfigFinalizado)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.totalFinalizados = data.count
            this.calculatePercentages()
          }
        })
    },
    calculatePercentages () {
      this.total = this.totalAndamento + this.totalFinalizados

      if (this.total > 0) {
        this.percentages = [
          Math.round((this.totalAndamento / this.total) * 100),
          Math.round((this.totalFinalizados / this.total) * 100)
        ]
      } else {
        this.percentages = [0, 0] // ou outra lógica de fallback
      }
    },
    formatTime (milliseconds) {
      const hours = Math.floor(milliseconds / 3600000)
      const minutes = Math.floor((milliseconds % 3600000) / 60000)
      const seconds = Math.floor((milliseconds % 60000) / 1000)

      let formattedTime = ''

      if (hours > 0) {
        formattedTime += `${this.pad(hours)} Horas `
      }
      if (minutes > 0 || hours > 0) {
        formattedTime += `${this.pad(minutes)} Minutos `
      }
      if (seconds > 0 || minutes > 0 || hours > 0) {
        formattedTime += `${this.pad(seconds)} Segundos `
      }

      return formattedTime.trim()
    },
    pad (number) {
      return number < 10 ? '0' + number : number
    },
    onSearch (filters, filtersAndamento) {
      this.filters = filters
      this.filtersAndamento = filtersAndamento
      this.$nextTick(() => {
        this.getAndamento()
        this.getFinalizado()
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-container {
  max-width: 400px;
  min-width: 400px;
  background-color: #f8f9fa;
  padding: 20px
}

.rating {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0px;
}

.star {
  font-size: 1.5rem;
  color: #e4e5e9;
  transition: color 0.2s;
}

.star.filled {
  color: #0BACA0;
}

.star.failed {
  color: #f03535;
}

.rating-text {
  margin-left: 10px;
  font-size: 1rem;
}

.card-text {
  font-size: 1.25rem;
}

.no-data {
  font-size: 1rem;
  color: #6c757d;
}

@media (max-width: 576px) {
  .container-fluid {
    padding: 10px;
    align-items: stretch;
  }

  .chart-container {
    max-width: 100% !important;
    min-width: auto;
    padding: 10px;
    margin-bottom: 20px;
  }

  .card-body {
    padding: 10px;
    text-align: center;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .card-text {
    font-size: 1rem;
  }

  .rating-text {
    font-size: 0.9rem;
    margin-left: 0;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .defaultbutton {
    width: 100%;
    justify-content: center;
  }

  .row > .col-12.col-md-3.ml-auto {
    margin-left: 0 !important;
  }

  h3 {
    font-size: 1.40rem;
    text-align: center;
  }

  .fa-user-circle {
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/indice_atendimento/indice.vue